import {
  FC,
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import React from 'react';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import {
  Image,
  KeyboardAvoidingView,
  NativeScrollEvent,
  NativeSyntheticEvent,
  ScrollView,
  Text,
  TouchableOpacity,
  useWindowDimensions,
  View,
} from 'react-native';
import { IS_IOS, IS_WEB, MAX_WIDTH } from '../../constants/platform';
import MyAccountMenu from '../../components/MyAccountMenu/MyAccountMenu';
import PageTitle from '../../components/PageTitle';
import { COLORS, FONTS } from '../../constants';
import { TextInput } from '../../components/TextInput/TextInput';
import ReceiveMessage from './components/ReceiveMessage';
import SendMessage from './components/SendMessage';
import { Footer } from '../../components/Footer';
import { NavigationService } from '../../services/navigation';
import { MessagesUserScreenProps } from './types';
import Pusher from 'pusher-js';
import { useSelector } from 'react-redux';
import { RootState } from '../../services/redux';
import usePusherChannel from '../../hooks/usePusherChannel';
import { IChatRoom, IMessage } from '../../types/chat.types';
import ChatRoomApi from '../../services/api/chatroom.api';
import { Alert } from '../../services/alert';
import { Loading } from '../../components';
import dayjs from 'dayjs';
import createPusherClient from '../../services/utils/pusher';
import { useActionSheet } from '@expo/react-native-action-sheet';
import {
  launchImageLibrary,
  launchCamera,
  Asset,
} from 'react-native-image-picker';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import PusherSingleton from '../../services/pusher/PusherSingleton';
import { useFocusEffect } from '@react-navigation/native';
dayjs.extend(utc);
dayjs.extend(timezone);

const getHongKongDateTime = () => {
  const hongKongTime = dayjs().utc().add(8, 'hour');
  const formattedTime = hongKongTime.format('YYYY-MM-DD HH:mm:ss');

  return formattedTime;
};

const MessagesUser: FC<MessagesUserScreenProps> = ({ navigation, route }) => {
  const roomId = route.params.id;
  const [now, setNow] = useState<string>(getHongKongDateTime());
  const [chatRoom, setChatRoom] = useState<IChatRoom>();
  const [messages, setMessages] = useState<IMessage[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingMessages, setIsLoadingMessages] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);
  const [messageInput, setMessageInput] = useState<string>('');
  const chatRoomRef = useRef<ScrollView>(null);
  const contentHeight = useRef<number>(0);
  const inputFileRef = useRef<HTMLInputElement>(null);

  const { showActionSheetWithOptions } = useActionSheet();

  const { access_token, user } = useSelector(
    (redux: RootState) => redux.authReducer
  );
  const isDesktop = useIsDesktop();
  const { height: screenHeight } = useWindowDimensions();

  const sendMessage = async (content: string) => {
    var formData = new FormData();
    formData.append('content', content);
    ChatRoomApi.postSendMessage(roomId, formData)
      .then((res) => {})
      .catch((error) => {
        Alert.alert('Error', error.meta.message);
      });
  };

  const sendImageMessage = useCallback(
    async (images: any) => {
      var formData = new FormData();
      formData.append('type', 'image');
      images.forEach((image: any) => {
        formData.append('images[]', image);
      });

      formData.append('images', images);
      ChatRoomApi.postSendMessage(roomId, formData)
        .then((res) => {})
        .catch((error) => {
          Alert.alert('Error', error.meta.message);
        });
    },
    [roomId]
  );

  const markAsRead = useCallback(async () => {
    ChatRoomApi.postChatRoomRead(roomId);
  }, [roomId]);

  const getChatRoom = async () => {
    setIsLoading(true);
    ChatRoomApi.getChatRoomDetail(roomId)
      .then((res) => {
        setChatRoom(res.data.data);
      })
      .catch((error) => {
        Alert.alert('Error', error.meta.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getMessages = useCallback(
    async (pageNum: number) => {
      setIsLoadingMessages(true);
      ChatRoomApi.getChatRoomMessages(roomId, pageNum, now)
        .then((res) => {
          const newMessages: IMessage[] = res.data.data.data;
          setMessages((prevMessages) => [
            ...newMessages.reverse(),
            ...prevMessages,
          ]);
          setTotal(res.data.data.total);
        })
        .catch((error) => {
          Alert.alert('Error', error.meta.message);
        })
        .finally(() => {
          setIsLoadingMessages(false);
        });
    },
    [roomId, now]
  );

  const handleScroll = useCallback(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      const { nativeEvent } = event;
      if (
        nativeEvent.contentOffset.y <= 0 &&
        messages.length < total &&
        !isLoadingMessages
      ) {
        getMessages(page + 1);
        setPage(page + 1);
      }
    },
    [getMessages, isLoadingMessages, messages, page, total]
  );

  const handleUploadImage = useCallback(() => {
    if (IS_WEB) {
      if (inputFileRef.current) {
        inputFileRef.current.click();
      }
    } else {
      {
        /* Disable on website */
      }
      // const options = ['Take Photo', 'Choose from Library', 'Cancel'];
      // const cancelButtonIndex = 2;
      // showActionSheetWithOptions(
      //   {
      //     options,
      //     cancelButtonIndex,
      //   },
      //   async (selectedIndex: number | undefined) => {
      //     switch (selectedIndex) {
      //       case 0:
      //         // Take Photo
      //         const cameraResult = await launchCamera({
      //           mediaType: 'photo',
      //         });
      //         if (cameraResult.assets)
      //           sendImageMessage([
      //             {
      //               uri: cameraResult.assets[0].uri,
      //               name: cameraResult.assets[0].fileName,
      //               type: cameraResult.assets[0].type,
      //             } as any,
      //           ]);
      //         break;
      //       case 1:
      //         const libraryResult = await launchImageLibrary({
      //           mediaType: 'photo',
      //         });
      //         if (libraryResult.assets)
      //           sendImageMessage([
      //             {
      //               uri: libraryResult.assets[0].uri,
      //               name: libraryResult.assets[0].fileName,
      //               type: libraryResult.assets[0].type,
      //             } as any,
      //           ]);
      //         break;
      //       case cancelButtonIndex:
      //       // Canceled
      //     }
      //   }
      // );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showActionSheetWithOptions, sendImageMessage]);

  const handleContentSizeChange = (
    contentWidth: number,
    contentHeights: number
  ) => {
    if (contentHeights > contentHeight.current) {
      if (chatRoomRef.current) {
        chatRoomRef.current.scrollTo({
          y: contentHeights - contentHeight.current,
          animated: false,
        });
      }
    }
    contentHeight.current = contentHeights;
  };

  const renderChatbox = useMemo(() => {
    return (
      <View>
        <ScrollView
          style={{
            // height: isDesktop() ? 450 : screenHeight - 212 - (IS_IOS ? 80 : 0),
            height: isDesktop() ? 450 : undefined,
            flexDirection: 'column',
          }}
          ref={chatRoomRef}
          onScroll={handleScroll}
          scrollEventThrottle={16}
          onContentSizeChange={handleContentSizeChange}
        >
          {isLoadingMessages && <Loading />}
          <View
            style={{
              flexDirection: 'column',
              minHeight: screenHeight / 3,
            }}
          >
            {messages.map((message, index) => (
              <>
                {message.user_id != user?.id ? (
                  <ReceiveMessage
                    media={message.media}
                    content={message.content}
                    time={dayjs(new Date(message.created_at)).format('HH:mm')}
                    type={message.type}
                  />
                ) : (
                  <SendMessage
                    media={message.media}
                    content={message.content}
                    time={dayjs(new Date(message.created_at)).format('HH:mm')}
                    type={message.type}
                  />
                )}
              </>
            ))}
          </View>
        </ScrollView>
        {IS_WEB && (
          <input
            type={'file'}
            id={'photo_upload'}
            name={'file'}
            ref={inputFileRef}
            style={{
              width: 0.1,
              height: 0.1,
              opacity: 0,
              overflow: 'hidden',
              position: 'absolute',
              zIndex: -1,
            }}
            accept="image/png, image/jpg, image/jpeg"
            onChange={(e) => {
              if (e.currentTarget.files && e.currentTarget.files[0]) {
                sendImageMessage([e.currentTarget.files[0]]);
              }
            }}
          />
        )}
      </View>
    );
  }, [
    screenHeight,
    isDesktop,
    messages,
    handleScroll,
    isLoadingMessages,
    user?.id,
    sendImageMessage,
  ]);

  useFocusEffect(
    useCallback(() => {
      // Screen is focused (user is on the screen)
      const pusher = createPusherClient(access_token ? access_token : '');
      const channel = pusher.subscribe(`private-App.Rooms.${roomId}`);

      channel.bind('pusher:subscription_succeeded', () => {
        console.log(
          `Successfully subscribed to channel: ${`private-App.Rooms.${roomId}`}`
        );
      });
      channel.bind('pusher:subscription_error', (status: any) => {
        console.error(
          `Subscription error on ${`private-App.Rooms.${roomId}`}:`,
          status
        );
      });
      channel.bind(
        'room-message-sent',
        (data: { message: IMessage; room: IChatRoom }) => {
          markAsRead();
          setMessages((prevMessages) => [...prevMessages, data.message]);

          setTimeout(() => {
            chatRoomRef?.current?.scrollToEnd({ animated: true });
          }, 200);
        }
      );

      return () => {
        // Screen is unfocused (user is leaving the screen)
        console.log('Unsubscribing from channel');
        channel.unbind_all();
        // Clean up from singleton as well
        pusher.unsubscribe(`private-App.Rooms.${roomId}`);
        pusher.disconnect();
        console.log('Cleanup finished');
      };
    }, [access_token, roomId, markAsRead])
  );

  useEffect(() => {
    markAsRead();
    getChatRoom();
    getMessages(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (chatRoomRef.current && page === 1 && !isLoading) {
        chatRoomRef.current.scrollToEnd({ animated: false });
      }
    }, 300);
    // eslint-disable-next-line
  }, [isLoading]);

  if (isDesktop()) {
    return (
      <ScrollView showsVerticalScrollIndicator={false}>
        <View
          style={{
            maxWidth: MAX_WIDTH,
            width: '90%',
            marginHorizontal: 'auto',
            paddingTop: 40,
            marginBottom: 200,
          }}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
            }}
          >
            <View style={{ width: '22%', minWidth: 230, marginRight: 20 }}>
              <MyAccountMenu />
            </View>
            <View style={{ width: '70%' }}>
              {isLoading ? (
                <View style={{ marginVertical: 30 }}>
                  <Loading />
                </View>
              ) : (
                <>
                  <View
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      marginBottom: 20,
                    }}
                  >
                    <TouchableOpacity
                      onPress={() => {
                        NavigationService.push('Root', {
                          screen: 'Messages',
                        });
                      }}
                    >
                      <Image
                        source={require('../../assets/arrow-left.png')}
                        style={{
                          width: 30,
                          height: 30,
                          tintColor: '#575757',
                          marginRight: 8,
                        }}
                      />
                    </TouchableOpacity>
                    <View
                      style={{
                        flexDirection: 'row',
                        gap: 15,
                        alignItems: 'center',
                      }}
                    >
                      <Image
                        source={{ uri: chatRoom?.avatar }}
                        style={{
                          width: 55,
                          height: 55,
                          borderRadius: 55,
                        }}
                      />
                      <View>
                        <Text
                          style={{
                            fontFamily: FONTS.AvenirMedium,
                            fontWeight: '800',
                            fontSize: 19,
                            letterSpacing: 1,
                            color: COLORS.BLACK,
                          }}
                        >
                          {chatRoom?.name_html}
                        </Text>
                        <Text
                          style={{
                            fontFamily: FONTS.AvenirMedium,
                            fontWeight: '500',
                            fontSize: 16,
                            color: COLORS.GREY,
                          }}
                        >
                          {user?.is_online ? 'Online' : 'Offline'}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View
                    style={{
                      borderRadius: 18,
                      backgroundColor: COLORS.LIGHT_RED,
                      paddingHorizontal: 30,
                      paddingVertical: 40,
                      flexDirection: 'column',
                    }}
                  >
                    {renderChatbox}
                    <View
                      style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 20,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: 'row',
                          padding: 10,
                          backgroundColor: COLORS.WHITE,
                          borderWidth: 0.5,
                          borderColor: '#00000080',
                          borderRadius: 5,
                          width: '80%',
                          flex: 1,
                        }}
                      >
                        <TouchableOpacity
                          style={{
                            marginRight: 10,
                          }}
                          onPress={() => {
                            handleUploadImage();
                          }}
                        >
                          <Image
                            source={require('../../assets/camera.png')}
                            style={{
                              width: 30,
                              height: 25,
                              resizeMode: 'contain',
                            }}
                          />
                        </TouchableOpacity>
                        <TextInput
                          placeholder="Type your messages"
                          placeholderTextColor={COLORS.GREY}
                          style={{
                            fontFamily: FONTS.AvenirMedium,
                            fontSize: 16,
                            flex: 1,
                            color: COLORS.BLACK,
                          }}
                          value={messageInput}
                          onChangeText={(text) => {
                            setMessageInput(text);
                          }}
                          onSubmitEditing={() => {
                            sendMessage(messageInput);
                            setMessageInput('');
                          }}
                        />
                      </View>
                      <View
                        style={{
                          paddingRight: 50,
                        }}
                      >
                        <TouchableOpacity
                          onPress={() => {
                            sendMessage(messageInput);
                            setMessageInput('');
                          }}
                        >
                          <Image
                            source={require('../../assets/send-icon.png')}
                            style={{
                              width: 30,
                              height: 30,
                              resizeMode: 'contain',
                            }}
                          />
                        </TouchableOpacity>
                      </View>
                    </View>
                  </View>
                </>
              )}
            </View>
          </View>
        </View>
        <Footer />
      </ScrollView>
    );
  }

  return (
    <KeyboardAvoidingView
      style={{ flex: 1 }}
      behavior={IS_IOS ? 'padding' : undefined}
      keyboardVerticalOffset={IS_IOS ? 75 : 0}
    >
      {isLoading ? (
        <View style={{ marginVertical: 30 }}>
          <Loading />
        </View>
      ) : (
        <View
          style={{
            flex: 1,
            flexDirection: 'column',
          }}
        >
          <View
            style={{
              backgroundColor: COLORS.WHITE,
              width: '100%',
              flexDirection: 'row',
              paddingVertical: 8,
              paddingHorizontal: 15,
              justifyContent: 'flex-start',
              elevation: 4,
              shadowColor: '#0C0C0D1A',
              shadowOffset: { width: 0, height: 4 },
              shadowOpacity: 1,
              shadowRadius: 4,
              alignItems: 'center',
            }}
          >
            <TouchableOpacity
              style={{
                marginRight: 10,
              }}
              onPress={() => {
                NavigationService.push('Root', {
                  screen: 'Messages',
                });
              }}
            >
              <Image
                source={require('../../assets/arrow-left.png')}
                style={{
                  width: 30,
                  height: 30,
                  tintColor: COLORS.BLACK,
                }}
              />
            </TouchableOpacity>
            <View
              style={{
                flexDirection: 'row',
                gap: 15,
                alignItems: 'center',
              }}
            >
              <Image
                source={{ uri: chatRoom?.avatar }}
                style={{
                  width: 55,
                  height: 55,
                  borderRadius: 55,
                }}
              />
              <View>
                <Text
                  style={{
                    fontFamily: FONTS.AvenirMedium,
                    fontWeight: '800',
                    fontSize: 19,
                    letterSpacing: 1,
                    color: COLORS.BLACK,
                  }}
                >
                  {chatRoom?.name_html}
                </Text>
                <Text
                  style={{
                    fontFamily: FONTS.AvenirMedium,
                    fontWeight: '500',
                    fontSize: 16,
                    color: COLORS.GREY,
                  }}
                >
                  {user?.is_online ? 'Online' : 'Offline'}
                </Text>
              </View>
            </View>
          </View>
          <View
            style={{
              flex: 1,
              backgroundColor: COLORS.LIGHT_RED,
              flexDirection: 'column',
            }}
          >
            {renderChatbox}
          </View>
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 10,
              paddingBottom: IS_IOS ? 35 : 5,
              backgroundColor: COLORS.LIGHT_RED,
              paddingHorizontal: 5,
              paddingTop: 5,
            }}
          >
            <View
              style={{
                flexDirection: 'row',
                backgroundColor: COLORS.WHITE,
                borderWidth: 0.5,
                borderColor: '#00000080',
                borderRadius: 5,
                width: '80%',
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <TouchableOpacity
                style={{
                  marginRight: 5,
                  marginLeft: 5,
                }}
                onPress={() => {
                  handleUploadImage();
                }}
              >
                <Image
                  source={require('../../assets/camera.png')}
                  style={{
                    width: 30,
                    height: 25,
                    resizeMode: 'contain',
                  }}
                />
              </TouchableOpacity>
              <TextInput
                multiline={true}
                placeholder="Type your messages"
                placeholderTextColor={COLORS.GREY}
                style={{
                  fontFamily: FONTS.AvenirMedium,
                  fontSize: 16,
                  flex: 1,
                  paddingHorizontal: 10,
                  paddingVertical: 10,
                  color: COLORS.BLACK,
                }}
                value={messageInput}
                onChangeText={(text) => {
                  setMessageInput(text);
                }}
              />
            </View>
            <View
              style={{
                paddingRight: 10,
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  sendMessage(messageInput);
                  setMessageInput('');
                }}
              >
                <Image
                  source={require('../../assets/send-icon.png')}
                  style={{ width: 30, height: 30, resizeMode: 'contain' }}
                />
              </TouchableOpacity>
            </View>
          </View>
        </View>
      )}
    </KeyboardAvoidingView>
  );
};

export default MessagesUser;
